import script from "./MainLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainLoader.vue?vue&type=script&setup=true&lang=ts"

import "./MainLoader.vue?vue&type=style&index=0&id=787bb3f6&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787bb3f6"]])

export default __exports__